module.exports = __webpack_public_path__ + "img/bxc.c9174669.png";